<template>
	<div>
		<v-list color="transparent">
			<v-list-item-group
				v-model="selectedCategory"
				color="primary"
				class="category-table"
			>
				<v-list-item
					v-for="(existed_category, index) in categories"
					:key="index"
					:value="existed_category.id"
					link
					tag="a"
					style="cursor: pointer"
					:id="existed_category.id"
				>
					<v-list-item-action>
						<v-icon class="handle"> mdi-cursor-move </v-icon>
					</v-list-item-action>
					<v-list-item-content>
						<v-list-item-title>
							{{ existed_category.name }}
						</v-list-item-title>
					</v-list-item-content>
					<v-list-item-action>
						<v-icon
							@click="removeCategory(existed_category.id)"
							class="remove-category"
						>
							mdi-close
						</v-icon>
					</v-list-item-action>
				</v-list-item>
			</v-list-item-group>
		</v-list>

		<v-dialog v-model="categoryDialog" width="500" persistent>
			<ValidationObserver ref="categoryObs" v-slot="{ invalid }">
				<v-form>
					<v-card>
						<v-card-title class="grey lighten-2">
							Add Category
						</v-card-title>

						<v-card-text>
							<v-container grid-list-md>
								<v-layout row wrap>
									<v-flex xs12>
										<ValidationProvider
											name="category_id"
											rules="required"
											v-slot="{ errors }"
										>
											<v-autocomplete
												:items="available_categories"
												item-value="id"
												item-text="name"
												label="Please select available category"
												v-model="category.category_id"
												:error-messages="errors"
											></v-autocomplete>
										</ValidationProvider>
									</v-flex>
								</v-layout>
							</v-container>
						</v-card-text>

						<v-divider></v-divider>

						<v-card-actions>
							<v-spacer></v-spacer>
							<v-btn color="error" text @click="closeCategory()">
								Close
							</v-btn>
							<v-btn
								color="primary"
								:disabled="invalid"
								:loading="category.processing"
								@click.native="submitCategory()"
							>
								Submit
							</v-btn>
						</v-card-actions>
					</v-card>
				</v-form>
			</ValidationObserver>
		</v-dialog>
	</div>
</template>

<script>
import Sortable from "sortablejs";
export default {
	props: ["catalogue", "catalogue_categories", "available_categories"],
	data() {
		return {
			categoryDialog: false,
			category: this.$inertia.form({
				category_id: null,
				catalogue_id: this.catalogue.id,
			}),
			selectedCategory: null,
			categories: this.catalogue_categories,
		};
	},

	methods: {
		submitCategory() {
			this.category.post(
				this.$route("tenant.catalogue_cateogires.store", {
					tenant: this.$page.props.tenant.id,
					catalogue_id: this.catalogue.id,
					category_id: this.category_id,
				}),
				{
					preserveState: (page) =>
						page.props.flash.error ||
						Object.keys(page.props.errors).length > 0,
					preserveScroll: true,
				}
			);
			this.stepper = 2;
		},

		closeCategory() {
			this.categoryDialog = false;
		},

		removeCategory(id) {
			if (confirm("Are you sure want to delete this category?")) {
				this.$inertia.delete(
					this.$route("tenant.catalogue_cateogires.destroy", {
						tenant: this.$page.props.tenant.id,
						id: id,
					})
				);
			}
		},
	},

	mounted() {
		let table = document.querySelector(".category-table");
		const _self = this;
		Sortable.create(table, {
			handle: ".handle",
			async onUpdate({ item, newDraggableIndex, oldDraggableIndex }) {
				try {
					await axios.post(
						_self.$route("tenant.catalogue_categories.sort", {
							tenant: _self.$page.props.tenant.id,
							id: item.id,
							newIndex: newDraggableIndex,
							oldIndex: oldDraggableIndex,
						})
					);
					if (Object.keys(_self.$page.props.errors).length <= 0) {
						_self.$toast.open(
							"Category has been sorted successfully"
						);
					} else {
						_self.$toast.error(
							"Something went wrong while sorting the category"
						);
					}
				} catch (e) {
					_self.$toast.error(e.message);
				}
			},
		});
	},
};
</script>